import "./Profile.css";
import { Link } from "react-router-dom";
import { FiHelpCircle } from "react-icons/fi";
import { FaRegUserCircle } from "react-icons/fa";

import {
  MdOutlineDashboardCustomize,
  MdLogout,
  MdPeopleOutline,
} from "react-icons/md";

import useProfileImage from "../../hooks/useProfileImage";
import { SiCodeforces } from "react-icons/si";
import { getSessionItem } from "../../utils/helper/session";
import { stopWebTrackerRequest, updateLogTrackerStatusRequest } from "../../services/trackerServices/trackerService";

/**
 * @async
 * @function Profile
 * @param {Object} props 
 * @returns {JSX.Element} profile page component 
 */
 
function Profile() {  
  const user = getSessionItem("User");  
  const image = useProfileImage();  
  /**
   * @async
   * @function logout
   * @description - logs the user out of the system
   */
  async function logout() {
    const session = getSessionItem("session")

    let jobId = sessionStorage.getItem("jobID");    
    if (jobId !== null) {
      let keys = {
        username: user.email,
      };

      await stopWebTrackerRequest(keys)     
      await updateLogTrackerStatusRequest(session, false);      
    }
    sessionStorage.clear();
    localStorage.clear();   
    window.location.href = "/";
  }

  return (
    <div className="profile-full" id="header-profile">
      <div className="profile-box" id="profile-menu">
        {image !== null && (
          <div className="profile-box-small">
            <div>
              <img className="profile-image" src={image} alt="profileImage" />
            </div>
            <div className="profile-details">
              <div className="profile-name">
                {user.firstName + " " + user.lastName}
              </div>
              <div className="designation">
                {user.roleName || user.jobDescription}
              </div>
            </div>
          </div>
        )}
        <div className="profile-navigation">
          <div>
            {user.roleName == "Manager" ||
              (user.roleName == "VP" && (
                <Link to="/manager">
                  <MdPeopleOutline /> Manager Dashboard
                </Link>
              ))}
          </div>
          {user.roleName !== "Customer" && user.roleName !== "Applicant" && (
            <>
            <div>
              <Link to="/summary">
                <MdOutlineDashboardCustomize /> My Dashboard
              </Link>
            </div>
            <div>
              <a
                href={import.meta.env.VITE_WFM_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiCodeforces /> Workforce Management
              </a>
            </div>
            </>
          )}
          <div>
            {user.roleName != "Customer" && (
              <Link to="/profile/info">
                <FaRegUserCircle /> Profile
              </Link>
            )}
          </div>
          <div>
            {user.roleName == "Customer" && user.roleName !== "Applicant" && (
              <Link to="/team">
                <MdPeopleOutline /> Team Dashboard
              </Link>
            )}
          </div>
          <div>
            <a
              href="https://sirius-support.atlassian.net/servicedesk/customer/portals"
              target="_blank"
            >
              <FiHelpCircle /> Help
            </a>
          </div>
          <div>
            <Link onClick={logout}>
              <MdLogout /> Logout
            </Link>
          </div>
        </div>
      </div>
      <div className="notifications"></div>
    </div>
  );
}

export default Profile;
